import React from 'react';

import {IFooterSelectorsItemProps} from './IFooterSelectorsItem';

import styles from './FooterSelectorsItem.module.scss';

const FooterSelectorsItem = ({children}: IFooterSelectorsItemProps) => {
	return <li className={styles['footer__navigation__select']}>{children}</li>;
};

export default FooterSelectorsItem;
